<template>
  <v-list>
    <v-list-item
      v-for="(whatsapp, i) in fornecedorEnvio.whatsapps"
      :key="i"
      :value="whatsapp"
      color="primary">
      <v-list-item-title>
        {{ formatWhats(whatsapp) | naoInformado }}
      </v-list-item-title>
      <v-list-item-action v-if="hasRoleComprador">
        <v-btn icon small @click="remove(whatsapp)">
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="!fornecedorEnvio.whatsapps.length">
      <v-list-item-title class="texto">
        Nenhum whatsapp encontrado
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
import Vue from 'vue';
import GestaoFornecedorService from '@/modules/gestao-fornecedor/gestao-fornecedor-service';

export default {
  props: {
    hasRoleComprador: Boolean,
    fornecedor: Object,
    isNacional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fornecedorEnvio: {
        whatsapps: [],
      },
    };
  },
  computed: {
    formatWhats() {
      return whatsapp => (this.isNacional ? Vue.filter('phone')(whatsapp) : whatsapp);
    },
  },
  methods: {
    remove(item) {
      const fornecedor = { ...this.fornecedorEnvio };
      fornecedor.whatsapps = fornecedor.whatsapps.filter(
        whats => whats !== item,
      );
      this.save(fornecedor);
    },
    save(fornecedor) {
      GestaoFornecedorService.updateWhatsapp(this.fornecedor.id, fornecedor)
        .then(() => {
          this.$toast('Whatsapp removido', { color: 'success' });
          this.getWhatsapps();
        });
    },
    getWhatsapps() {
      GestaoFornecedorService.get(this.fornecedor.id)
        .then((response) => {
          const fornecedor = response.data;
          this.fornecedorEnvio.whatsapps = fornecedor.whatsapps || [];
        });
    },
  },
  created() {
    this.getWhatsapps();
  },
};
</script>
<style scoped>
.texto {
  font-size: 0.9rem;
}
</style>
